import React from 'react';
import { toast as rtToast } from 'react-toastify';
import CustomToast from './CustomToast';

const renderCustomToast = (message, type) => ({ closeToast, data }) => (
  <CustomToast
    closeToast={closeToast}
    data={{ message: data?.message ?? message, type: data?.type ?? type }}
  />
);

const defaultOptions = {
  className: 'wms-custom-toast',
  icon: false,
  closeButton: false,
};

/** Previous ToastContainer default — keep info/warning auto-dismiss unchanged. */
const INFO_WARNING_AUTO_CLOSE_MS = 3000;

export const success = (message, options = {}) =>
  rtToast(renderCustomToast(message, 'success'), {
    ...defaultOptions,
    ...options,
    // Persist until user clicks X (ignore per-call autoClose overrides)
    autoClose: false,
    data: { ...options.data, message, type: 'success' },
  });

export const error = (errOrMsg, options = {}) => {
  const message =
    typeof errOrMsg === 'string'
      ? errOrMsg
      : errOrMsg?.response?.data?.message ||
        errOrMsg?.response?.data?.error ||
        errOrMsg?.message ||
        'Something went wrong';
  return rtToast(renderCustomToast(message, 'error'), {
    ...defaultOptions,
    ...options,
    // Persist until user clicks X (ignore per-call autoClose overrides)
    autoClose: false,
    data: { ...options.data, message, type: 'error' },
  });
};

export const warning = (message, options = {}) =>
  rtToast(renderCustomToast(message, 'warning'), {
    ...defaultOptions,
    autoClose: INFO_WARNING_AUTO_CLOSE_MS,
    ...options,
    data: { ...options.data, message, type: 'warning' },
  });

export const info = (message, options = {}) =>
  rtToast(renderCustomToast(message, 'info'), {
    ...defaultOptions,
    autoClose: INFO_WARNING_AUTO_CLOSE_MS,
    ...options,
    data: { ...options.data, message, type: 'info' },
  });

const toast = {
  success,
  error,
  warning,
  info,
  dismiss: rtToast.dismiss,
  isActive: rtToast.isActive,
  update: rtToast.update,
  promise: rtToast.promise,
};

export default toast;
